
import { Component, Vue, Prop } from 'vue-property-decorator';
import { SummaryReceiptModel } from '@/models/summary-receipt';
import { APP_CONFIG } from '@/config/app-config';

@Component
export default class SummaryReceipt extends Vue {
    @Prop({default: null})
    private summaryReceipt!: SummaryReceiptModel;
}
